import { House, ChatText, Suitcase, User } from '@phosphor-icons/react';
import Sidebar, { NavItem } from '@/components/layout/Sidebar';
import logo from '@/assets/icon/logo-icon.svg';
import useAuth from '@/store/auth';

const ICON_SIZE = 24;

const USER_NAV_ITEMS: Omit<NavItem, 'isActive'>[] = [
  {
    id: 0,
    name: 'Home',
    icon: <House size={ICON_SIZE} />,
    to: '/'
  },
  {
    id: 1,
    name: 'Jobs',
    icon: <Suitcase size={ICON_SIZE} />,
    to: '/job'
  },
  {
    id: 2,
    name: 'Candidates',
    icon: <User size={ICON_SIZE} />,
    to: '/candidate'
  },
  {
    id: 3,
    name: 'Interview',
    icon: <ChatText size={ICON_SIZE} />,
    to: '/interview'
  }
];

export default function UserSidebar() {
  const { logout } = useAuth();

  return (
    <Sidebar
      navItems={USER_NAV_ITEMS}
      logo={logo}
      logoAlt="Polaris Jobs Logo"
      onLogout={logout}
      showInbox
      showProfile
      showTutorial
    />
  );
}
